// Import pages
import Vue from 'vue'
import VueRouter from 'vue-router'

// import components
import Reserve from '@/pages/Reserve'
import Checkout from '@/pages/Checkout'
import Person from '@/pages/Person'
import Signin from '@/pages/Signin'
import Reservations from '@/pages/Reservations'
import Invoices from '@/pages/Invoices'
import Print from '@/pages/Print'
import Reports from '@/pages/Reports'
import Settings from '@/pages/Settings'
import ParkingAreas from '@/pages/ParkingAreas'
import Campgrounds from '@/pages/Campgrounds'
import Checkin from '@/pages/Checkin'
import CommercialPermits from '@/pages/CommercialPermits'

// import route children
import reserveChildren from '@/router/reserve'
import checkoutChildren from '@/router/checkout'
import personChildren from '@/router/person'
import signinChildren from '@/router/signin'
import printChildren from '@/router/print'
import reportsChildren from '@/router/reports'
import campgroundsChildren from '@/router/campgrounds'
import parkingAreasChildren from '@/router/parkingAreas'

// route guards
import store from '@/store/index'

Vue.use(VueRouter)

const Router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: {
        path: '/reserve'
      }
    },
    {
      path: '/reserve',
      name: 'Reserve',
      component: Reserve,
      children: reserveChildren
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: Checkout,
      redirect: '/checkout/main',
      children: checkoutChildren,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/person',
      name: 'Person',
      component: Person,
      redirect: '/person/profile',
      children: personChildren,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin,
      redirect: '/signin/login',
      children: signinChildren
    },
    {
      path: '/reservations',
      name: 'Reservations',
      component: Reservations,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/invoices',
      name: 'Invoices',
      component: Invoices,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/print',
      component: Print,
      children: printChildren,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reports',
      name: 'Reports',
      component: Reports,
      children: reportsChildren,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/settings',
      component: Settings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/parkingAreas',
      component: ParkingAreas,
      redirect: {
        path: '/parkingAreas/edit'
      },
      children: parkingAreasChildren,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/campgrounds',
      component: Campgrounds,
      redirect: {
        path: '/campgrounds/create'
      },
      children: campgroundsChildren,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/commercialPermits',
      component: CommercialPermits,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/checkin',
      component: Checkin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '*',
      redirect: {
        path: '/reserve'
      }
    }
  ]
}) // needed to check against

Router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters['person/authenticated']) {
      next({
        path: '/signin/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default Router
